// Legacy AYTM 3D surface plugin, moved as-is from public/javascripts/_d3/d3.surface3d.js.
// Side-effect module: patches `surface3D` onto the imported (module-scoped) d3 v3
// selection prototype. Only strict-mode fixes applied — implicit globals declared.
import d3 from '@aytm/app/stats/components/topography/d3v3'

;(function () {
  var FRAME_TIME = 17 // 60 FPS MAX

  var pointInPolygon = function (point, vs) {
    var x = point[0],
      y = point[1]
    var inside = false
    for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
      var xi = vs[i][0],
        yi = vs[i][1]
      var xj = vs[j][0],
        yj = vs[j][1]
      var intersect = yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
      if (intersect) inside = !inside
    }
    return inside
  }

  var Surface = function (node) {
    var colorFunction,
      strokeColorFunction,
      timer,
      flagColor, // strict-mode fix: setFlagColor wrote an implicit global (renderFrame shadows it either way)
      transformPrecalc = [],
      pins = [],
      flags = []
    var displayWidth = 300,
      displayHeight = 300,
      zoom = 1
    var displayCenterX = 150,
      displayCenterY = 150

    var transformPoint = function (point) {
      var x = transformPrecalc[0] * point[0] + transformPrecalc[1] * point[1] + transformPrecalc[2] * point[2]
      var y = transformPrecalc[3] * point[0] + transformPrecalc[4] * point[1] + transformPrecalc[5] * point[2]
      var z = transformPrecalc[6] * point[0] + transformPrecalc[7] * point[1] + transformPrecalc[8] * point[2]
      return [x, y, z]
    }
    var getTransformedData = function () {
      var data = node.datum()
      var t,
        output = []
      var xyzRow,
        xyz = []
      var xlength = data.length
      var ylength = data[0].length
      var max = []
      var min = []
      for (var x = 0; x < xlength; x++) {
        output.push((t = []))
        xyz.push((xyzRow = []))
        for (var y = 0; y < ylength; y++) {
          var xyzp = [
            ((x - xlength / 2) / (xlength * 1.6)) * displayWidth * zoom,
            -data[x][y] * zoom,
            ((y - ylength / 2) / (ylength * 1.6)) * displayWidth * zoom
          ]
          xyzRow.push(xyzp)
          var xyzpt = transformPoint(xyzp)
          t.push(xyzpt)
        }
      }
      return { transformed: output, xyz: xyz }
    }
    var renderSurface = function () {
      if (timer) return
      else {
        timer = setTimeout(function () {
          renderFrame()
          timer = null
        }, FRAME_TIME)
      }
    }
    var renderFrame = function () {
      var originalData = node.datum()
      var transformed = getTransformedData()
      var data = transformed.transformed
      var xyzData = transformed.xyz
      var xlength = data.length
      var ylength = data[0].length
      var pathData = []
      var maxDepth = null
      var minDepth = null
      var maxHeight = null
      var minHeight = null
      var flagColor = function (height, minHeight, maxHeight, depth, minDepth, maxDepth) {
        var l = parseInt(d3.scale.linear().domain([minDepth, maxDepth]).range([255, 100]).clamp(true)(depth), 10)
        return 'rgb(' + l + ',' + l + ',' + l + ')'
      }
      for (var x = 0; x < xlength - 1; x++) {
        for (var y = 0; y < ylength - 1; y++) {
          var depth = Math.max(data[x][y][2], data[x + 1][y][2], data[x + 1][y + 1][2], data[x][y + 1][2])
          maxDepth = null === maxDepth ? depth : Math.max(maxDepth, depth)
          minDepth = null === minDepth ? depth : Math.min(minDepth, depth)
          maxHeight = null === maxHeight ? originalData[x][y] : Math.max(maxHeight, originalData[x][y])
          minHeight = null === minHeight ? originalData[x][y] : Math.min(minHeight, originalData[x][y])
          var polygon = [
            [
              parseFloat((data[x][y][0] + displayCenterX).toFixed(10)),
              parseFloat((data[x][y][1] + displayCenterY).toFixed(10))
            ],
            [
              parseFloat((data[x + 1][y][0] + displayCenterX).toFixed(10)),
              parseFloat((data[x + 1][y][1] + displayCenterY).toFixed(10))
            ],
            [
              parseFloat((data[x + 1][y + 1][0] + displayCenterX).toFixed(10)),
              parseFloat((data[x + 1][y + 1][1] + displayCenterY).toFixed(10))
            ],
            [
              parseFloat((data[x][y + 1][0] + displayCenterX).toFixed(10)),
              parseFloat((data[x][y + 1][1] + displayCenterY).toFixed(10))
            ]
          ]
          // surface
          pathData.push({
            path:
              'M' +
              polygon[0][0] +
              ',' +
              polygon[0][1] +
              ' L' +
              polygon[1][0] +
              ',' +
              polygon[1][1] +
              ' L' +
              polygon[2][0] +
              ',' +
              polygon[2][1] +
              ' L' +
              polygon[3][0] +
              ',' +
              polygon[3][1] +
              ' Z',
            depth: depth,
            data: originalData[x][y],
            polygon: polygon,
            className: 'data cell'
          })
          // pins
          if (null != pins) {
            var xyClaimed = {}
            for (var pi = 0; pi < pins.length; pi++) {
              var pin = pins[pi]
              if (pin.hidden === true) continue
              if (pin.x == x && pin.y == y) {
                var pinDepth = data[x][y][2] + 0.0000000001 //Math.max(data[x][y][2],data[x+1][y+1][2]);
                var pinX = parseFloat((data[x][y][0] + displayCenterX).toFixed(10))
                var pinY = parseFloat((data[x][y][1] + displayCenterY).toFixed(10))
                var pinColorFunction = (function (pin) {
                  return function (height, minHeight, maxHeight, depth, minDepth, maxDepth) {
                    return pin.color
                  }
                })(pin)
                var xyClaimedId = x + '-' + y
                if (null == xyClaimed[xyClaimedId]) xyClaimed[xyClaimedId] = { offset: 0, depthOffset: 0 }
                var claimed = xyClaimed[xyClaimedId]
                pathData.push({
                  path:
                    claimed.offset != 0
                      ? 'M' + pinX + ',' + (pinY + claimed.offset)
                      : 'M' + pinX + ',' + pinY + ' l' + -3 * zoom + ',-' + 15 * zoom + ' l' + 6 * zoom + ',0 Z',
                  depth: pinDepth + claimed.depthOffset,
                  colorFunction: pinColorFunction,
                  strokeColorFunction: pinColorFunction,
                  className: 'data pin',
                  pin: { x: pinX, y: pinY + claimed.offset, data: pin, i: pi, hideLabel: pin.label === false },
                  data: originalData[x][y]
                })
                claimed.offset -= 17 * zoom
                claimed.depthOffset -= 0.000000000001
              }
            }
          }
          // flags
          if (null != flags) {
            for (var fi = 0; fi < flags.length; fi++) {
              var flag = flags[fi]
              if (flag.hidden === true) continue
              if (flag.x == x && flag.y == y) {
                var flagDepth = data[x][y][2] + 0.0000000000001
                var flagX = parseFloat((data[x][y][0] + displayCenterX).toFixed(10))
                var flagY = parseFloat((data[x][y][1] + displayCenterY).toFixed(10))
                var flagPoint = xyzData[x][y]
                var flagTopPoint = [flagPoint[0], -270, flagPoint[2]]
                var transformedFlagTopPoint = transformPoint(flagTopPoint)
                var flagTopY = parseFloat((transformedFlagTopPoint[1] + displayCenterY).toFixed(10))
                pathData.push({
                  path:
                    'M' +
                    flagX +
                    ',' +
                    flagY +
                    ' L' +
                    flagX +
                    ',' +
                    flagTopY +
                    ' l' +
                    15 * zoom +
                    ',' +
                    4 * zoom +
                    ' l' +
                    -15 * zoom +
                    ',' +
                    4 * zoom +
                    '',
                  depth: flagDepth,
                  colorFunction: flagColor,
                  strokeColorFunction: flagColor,
                  className: 'data flag',
                  flag: { x: flagX, y: flagY, topY: flagTopY, data: flag, i: fi },
                  data: originalData[x][y]
                })
                break
              }
            }
          }
        }
      }

      pathData.sort(function (a, b) {
        return b.depth - a.depth
      })

      if (null != pins) {
        for (var i = 0; i < pathData.length; i++) {
          var d = pathData[i]
          if (null != d.pin) {
            d.pin.overlapped || (d.pin.overlapped = {})
            d.pin.overlapped.left = false
            d.pin.overlapped.right = false
            for (var j = i + 1; j < pathData.length; j++) {
              var dp = pathData[j]
              if (null != dp.pin || null == dp.polygon) continue
              if (pointInPolygon([d.pin.x + 10, d.pin.y - 20], dp.polygon)) {
                d.pin.overlapped.right = true
                if (d.pin.overlapped.left && d.pin.overlapped.right) break
              }
              if (pointInPolygon([d.pin.x - 10, d.pin.y - 20], dp.polygon)) {
                d.pin.overlapped.left = true
                if (d.pin.overlapped.left && d.pin.overlapped.right) break
              }
            }
            d.pin.overlapped.totally = d.pin.overlapped.left && d.pin.overlapped.right
          }
        }
      }

      var cells = node.selectAll('path.data').data(pathData)
      cells.enter().append('path')
      cells.exit().remove()
      cells
        .attr('d', function (d) {
          return d.path
        })
        .attr('class', function (d) {
          return d.className
        }) //.attr("data-depth",function(d){return d.depth;});
      if (colorFunction)
        cells.attr('fill', function (d) {
          return d.colorFunction
            ? d.colorFunction(d.data, minHeight, maxHeight, d.depth, minDepth, maxDepth)
            : colorFunction(d.data, minHeight, maxHeight, d.depth, minDepth, maxDepth)
        })
      if (strokeColorFunction)
        cells.attr('stroke', function (d) {
          return d.strokeColorFunction
            ? d.strokeColorFunction(d.data, minHeight, maxHeight, d.depth, minDepth, maxDepth)
            : strokeColorFunction(d.data, minHeight, maxHeight, d.depth, minDepth, maxDepth)
        })
      cells.filter('.pin').each(function (d) {
        if (null == d.pin) return
        var pinIndex = d.pin.i || 0
        var pinG = node.select('#pin-' + pinIndex)
        if (pinG.empty()) {
          pinG = d3.select(document.createElementNS('http://www.w3.org/2000/svg', 'g'))
          pinG.on(
            'mouseenter',
            (function (pinIndex, _this) {
              return function () {
                var pinLabel = node.select('#pin-label-' + pinIndex)
                if (!pinLabel.empty()) {
                  _this.parentNode.appendChild(pinLabel.node())
                }
              }
            })(pinIndex, this)
          )
          if (pinG.node()) this.parentNode.insertBefore(pinG.node(), this)
          pinG.attr('id', 'pin-' + pinIndex)
          pinG.attr('class', 'pin-g')
          pinG.attr('transform', 'translate(' + d.pin.x + ',' + d.pin.y + ') scale(' + zoom + ',' + zoom + ')')
          pinG
            .append('circle')
            .attr('class', 'pin-outerc')
            .attr('cx', 0)
            .attr('cy', -20)
            .attr('r', 10)
            .attr(
              'fill',
              d.colorFunction
                ? d.colorFunction(d.data, minHeight, maxHeight, d.depth, minDepth, maxDepth)
                : colorFunction(d.data, minHeight, maxHeight, d.depth, minDepth, maxDepth)
            )
            .attr(
              'stroke',
              d.strokeColorFunction
                ? d.strokeColorFunction(d.data, minHeight, maxHeight, d.depth, minDepth, maxDepth)
                : strokeColorFunction(d.data, minHeight, maxHeight, d.depth, minDepth, maxDepth)
            )
          pinG
            .append('circle')
            .attr('class', 'pin-innerc')
            .attr('cx', 0)
            .attr('cy', -20)
            .attr('r', 3.5)
            .attr('fill', '#000')
            .attr('stroke', '#000')
          if (!d.pin.hideLabel) {
            var textLabelG = node
              .append('g')
              .attr('id', 'pin-label-' + pinIndex)
              .attr('class', 'pin-label' + (d.pin.overlapped.totally ? ' pin-label-hidden' : ''))
              .attr('transform', 'translate(' + d.pin.x + ',' + d.pin.y + ') scale(' + zoom + ')')
            var textLabelT = textLabelG
              .append('text')
              .attr('class', 'pin-label-text')
              .attr('x', 40)
              .attr('y', -8)
              .attr('fill', '#FFF')
              .attr('stroke', 'none')
              .text(d.pin.data.text)
            setTimeout(function () {
              try {
                var textLabelBBox = textLabelT.node().getBBox()
              } catch (e) {
                var textLabelBBox = null
              }
              if (null != textLabelBBox && textLabelBBox.width > 0) {
                var pinLabelRight =
                  (!d.pin.overlapped.right &&
                    d.pin.x >= displayCenterX &&
                    d.pin.x < displayWidth - textLabelBBox.width - 60) ||
                  (d.pin.overlapped.left && d.pin.x < displayCenterX && d.pin.x > textLabelBBox.width + 60) ||
                  (!d.pin.overlapped.right && d.pin.x < textLabelBBox.width + 60)
                if (!pinLabelRight) textLabelT.attr('x', -textLabelBBox.width - 40)
                textLabelG
                  .insert('path', 'text.pin-label-text')
                  .attr('class', 'pin-label-bg')
                  .attr(
                    'd',
                    'M10,' +
                      (textLabelBBox.y - 2) +
                      ' l' +
                      (16 + textLabelBBox.width + 30) +
                      ',0' +
                      ' l0,' +
                      (textLabelBBox.height + 4) +
                      ' l-' +
                      (textLabelBBox.width + 30) +
                      ',0' +
                      ' l0,-' +
                      (textLabelBBox.height - 4) +
                      ' Z'
                  )
                  .attr('stroke', 'none')
                  .attr('transform', 'scale(' + (pinLabelRight ? '1' : '-1') + ',1)')
                  .attr('fill', 'rgba(80,80,80,.75)')
              }
            }, 0)
          }
        } else {
          pinG.attr('transform', 'translate(' + d.pin.x + ',' + d.pin.y + ') scale(' + zoom + ',' + zoom + ')')
          if (!d.pin.hideLabel) {
            var pinLabel = node.select('#pin-label-' + pinIndex)
            var pinTextLabelT = pinLabel.select('.pin-label-text')
            try {
              var pinTextLabelBBox = pinTextLabelT.node().getBBox()
            } catch (e) {
              var pinTextLabelBBox = null
            }
            if (null != pinTextLabelBBox && pinTextLabelBBox.width > 0) {
              var pinLabelRight =
                (!d.pin.overlapped.right &&
                  d.pin.x >= displayCenterX &&
                  d.pin.x < displayWidth - pinTextLabelBBox.width - 60) ||
                (d.pin.overlapped.left && d.pin.x < displayCenterX && d.pin.x > pinTextLabelBBox.width + 60) ||
                (!d.pin.overlapped.right && d.pin.x < pinTextLabelBBox.width + 60)
              pinTextLabelT.attr('x', pinLabelRight ? 40 : -pinTextLabelBBox.width - 40)
              var pinLabelBG = pinLabel.select('.pin-label-bg')
              if (pinLabelBG.empty()) {
                pinLabel
                  .insert('path', 'text.pin-label-text')
                  .attr('class', 'pin-label-bg')
                  .attr(
                    'd',
                    'M10,' +
                      (pinTextLabelBBox.y - 2) +
                      ' l' +
                      (16 + pinTextLabelBBox.width + 30) +
                      ',0' +
                      ' l0,' +
                      (pinTextLabelBBox.height + 4) +
                      ' l-' +
                      (pinTextLabelBBox.width + 30) +
                      ',0' +
                      ' l0,-' +
                      (pinTextLabelBBox.height - 4) +
                      ' Z'
                  )
                  .attr('stroke', 'none')
                  .attr('transform', 'scale(' + (pinLabelRight ? '1' : '-1') + ',1)')
                  .attr('fill', 'rgba(80,80,80,.75)')
              } else pinLabelBG.attr('transform', 'scale(' + (pinLabelRight ? '1' : '-1') + ',1)')
            }
            pinLabel
              .attr('transform', 'translate(' + d.pin.x + ',' + d.pin.y + ') scale(' + zoom + ',' + zoom + ')')
              .attr('class', 'pin-label' + (d.pin.overlapped.totally ? ' pin-label-hidden' : ''))
          }
          if (pinG.node()) this.parentNode.insertBefore(pinG.node(), this)
        }
      })
      cells.filter('.flag').each(function (d) {
        var flagIndex = d.flag.i || 0
        var flagG = node.select('#flag-' + flagIndex)
        if (flagG.empty()) {
          flagG = d3.select(document.createElementNS('http://www.w3.org/2000/svg', 'g'))
          flagG.attr('id', 'flag-' + flagIndex)
          flagG.attr('class', 'flag-g')
          flagG.attr('transform', 'translate(' + d.flag.x + ',' + d.flag.topY + ') rotate(-90)')
          flagG
            .append('text')
            .attr('class', 'flag-label')
            .attr('x', 0)
            .attr('y', -5)
            .attr('fill', d.colorFunction(d.data, minHeight, maxHeight, d.depth, minDepth, maxDepth))
            .attr('stroke', 'none')
            .attr('text-anchor', 'end')
            .text(d.flag.data.text)
        } else {
          flagG.attr('transform', 'translate(' + d.flag.x + ',' + d.flag.topY + ') rotate(-90)')
          flagG
            .select('.flag-label')
            .attr('fill', d.colorFunction(d.data, minHeight, maxHeight, d.depth, minDepth, maxDepth))
        }
        if (flagG.node()) this.parentNode.insertBefore(flagG.node(), this)
      })
    }
    this.renderSurface = renderSurface
    this.setTurtable = function (yaw, pitch) {
      var cosP = Math.cos(pitch)
      var sinP = Math.sin(pitch)
      var cosY = Math.cos(yaw)
      var sinY = Math.sin(yaw)
      transformPrecalc[0] = cosY
      transformPrecalc[1] = 0
      transformPrecalc[2] = sinY
      transformPrecalc[3] = sinP * sinY
      transformPrecalc[4] = cosP
      transformPrecalc[5] = -sinP * cosY
      transformPrecalc[6] = -sinY * cosP
      transformPrecalc[7] = sinP
      transformPrecalc[8] = cosP * cosY
      renderSurface()
      return this
    }
    this.setTurtable(0.5, 0.5)
    this.setZoom = function (zoomLevel) {
      zoom = zoomLevel
      renderSurface()
      return this
    }
    this.surfaceColor = function (callback) {
      colorFunction = callback
      renderSurface()
      return this
    }
    this.strokeColor = function (callback) {
      strokeColorFunction = callback
      renderSurface()
      return this
    }
    this.setHeight = function (height) {
      if (height) {
        displayHeight = height
        displayCenterY = height / 2
      }
    }
    this.setWidth = function (width) {
      if (width) {
        displayWidth = width
        displayCenterX = width / 2
      }
    }
    this.setCenter = function (CX, CY) {
      if (CX) displayCenterX = CX
      if (CY) displayCenterY = CY
      return this
    }
    this.setPins = function (p) {
      pins = p
      renderSurface()
      return this
    }
    this.setFlags = function (f) {
      flags = f
      renderSurface()
      return this
    }
    this.setFlagColor = function (fc) {
      flagColor = fc
      renderSurface()
      return this
    }
  }
  d3.selection.prototype.surface3D = function (width, height) {
    if (!this.node().__surface__) this.node().__surface__ = new Surface(this)
    var surface = this.node().__surface__
    this.turntable = surface.setTurtable
    this.surfaceColor = surface.surfaceColor
    this.strokeColor = surface.strokeColor
    this.setCenter = surface.setCenter
    this.pins = surface.setPins
    this.flags = surface.setFlags
    this.flagColor = surface.setFlagColor
    this.zoom = surface.setZoom
    surface.setHeight(height)
    surface.setWidth(width)
    return this
  }
})()
